import { PortfoliosSwitchSubPortfoliosService_portfolioSwitchSubPortfolioServicePostFrame } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosSwitchSubPortfoliosService_portfolioSwitchSubPortfolioServicePostFrame'

export const useFetchSwitchSubPortfolioFrame =
  PortfoliosSwitchSubPortfoliosService_portfolioSwitchSubPortfolioServicePostFrame.useSuspenseQuery
